import { render, staticRenderFns } from "./CreateFrame.vue?vue&type=template&id=fa6d7114&scoped=true&"
import script from "./CreateFrame.vue?vue&type=script&lang=ts&"
export * from "./CreateFrame.vue?vue&type=script&lang=ts&"
import style0 from "./CreateFrame.vue?vue&type=style&index=0&id=fa6d7114&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6d7114",
  null
  
)

export default component.exports